import React from "react";
import PropTypes from "prop-types";
import PlusCircle from "rialto-icons/PlusCircle";

import styles from "./AddButton.css";

const AddButton = ({ label, onClick }) => (
  <button className={styles.root} onClick={onClick} type="button">
    <PlusCircle size="small" />
    <span>{label}</span>
  </button>
);

AddButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AddButton;
